module.exports = __webpack_public_path__ + "static/media/F3.bbf57f5c.webp";